<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    :fullscreen="$vuetify.breakpoint.smAndDown && $router.currentRoute.name != 'Offer'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card store-list-dialog">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title class="header-title2">{{ $t("stores.stores") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align: right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <StoreList :order="orderClickAccept" ref="storeList" @onStoreClick="storeClicked($event)" @onOrderClick="orderClicked($event)"></StoreList>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import StoreList from "@/components/StoreList";
export default {
  components: {
    StoreList,
  },
  data: () => ({
    dialog: false,
    storeClickAccept: false,
    orderClickAccept: false,

    resolve: null,
    reject: null,
  }),

  computed: {},

  methods: {
    open(options) {
      this.dialog = true;
      if (options != null) {
        this.storeClickAccept = options.storeClickAccept == null ? false : options.storeClickAccept;
        this.orderClickAccept = options.orderClickAccept == null ? false : options.orderClickAccept;
      }

      this.refreshStores();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(null);
      this.dialog = false;
    },

    storeClicked(store) {
      if (!this.storeClickAccept) return;

      this.resolve(store);
      this.dialog = false;
    },

    orderClicked(store) {
      if (!this.orderClickAccept) return;

      this.resolve(store);
      this.dialog = false;
    },    
  },
};
</script>

<style lang="scss" scoped>
.v-card__text {
  font-size: 1em;
  color: black !important;
}
</style>
